// src/services/orcamentos/OrcamentoService.js
import { fetchBlobData, fetchData, postData, putData } from '../Api';

export const listarOrcamentos = filtros => fetchData('/Orcamento', filtros);
export const obterOrcamento = id => fetchData(`/Orcamento/${id}`);
export const obterOrcamentoDetalhado = id => fetchData(
  `/Orcamento/GetOrcamentoDetalhado/${id}`,
);
export const criarOrcamento = dados => postData('/Orcamento', dados);
export const atualizarOrcamento = (id, dados) => putData(`/Orcamento/${id}`, dados);
export const aprovarOrcamento = (id, dados) => postData(`/Orcamento/${id}/aprovar`, dados);
export const reprovarOrcamento = (id, dados) => postData(`/Orcamento/${id}/reprovar`, dados);
export const enviarOrcamentoWhatsApp = id => postData(`/Orcamento/${id}/enviar-whatsapp`, {});
export const obterPdfOrcamento = id => fetchBlobData(`/Orcamento/${id}/pdf`);
